module.exports = "/default/fonts/vendor/lightgallery.js/dist/lg.eot?ecff11700aad0000cf3503f537d1df17";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightgallery.js/dist/fonts/lg.eot?n1z373
// module id = UDpn
// module chunks = 0